import { Field, FieldArray, ErrorMessage, useFormikContext } from "formik";
import { Button, Label } from "reactstrap";

const SchemaFieldArray = () => {
  const { values } = useFormikContext<{ schemaJson: string[] }>(); // Get Formik values

  return (
    <div>
      <h5 className="mt-4">Schema Objects</h5>
      <FieldArray name="schemaJson">
        {({ push, remove }) => (
          <div>
            {values.schemaJson.map((schema, index) => (
              <div key={index} className="p-3 mb-3 border rounded">
                <Label>Schema Object {index + 1}</Label>
                <Field
                  as="textarea"
                  name={`schemaJson[${index}]`}
                  className="form-control"
                  rows={4}
                />
                <ErrorMessage
                  name={`schemaJson[${index}]`}
                  component="div"
                  className="text-danger"
                />
                <Button
                  type="button"
                  color="danger"
                  className="mt-2"
                  onClick={() => remove(index)}
                >
                  Remove
                </Button>
              </div>
            ))}
            <Button
              type="button"
              color="secondary"
              className="mt-2"
              onClick={() =>
                push('{"@context":"https://schema.org","@type":"BlogPosting"}')
              }
            >
              + Add Schema Object
            </Button>
          </div>
        )}
      </FieldArray>
    </div>
  );
};

export default SchemaFieldArray;
